import {getRandomElements} from "../shared/util";
import {getAudioForPhonemes} from "../shared/phonemeToAudio";

const baseUrl =
  "https://amira-assets.s3.amazonaws.com/images/sound_seeker_image";

export function getSoundSeekerImages(PHON, locale) {
  const phonIds = getPhonemeIds(PHON, locale);
  const phonIdStart = phonIds[0];
  const phonIdEnd = phonIds[phonIds.length - 1];

  const imageStart = getStartImageUrl(phonIdStart, locale);
  const imageEnd = getEndImageUrl(phonIdEnd, locale);

  const { startImages, endImages } = locale === 'es-mx' ? spanishImages : englishImages;
  const poolStart = Object.keys(startImages)
    .map(phoneme => getStartImageUrl(phoneme, locale))
    .filter((url) => url !== imageStart);
  const distractorsStart = getRandomElements(poolStart, 2);

  const poolEnd = Object.keys(endImages)
    .map(phoneme => getEndImageUrl(phoneme, locale))
    .filter((url) => url !== imageEnd);
  const distractorsEnd = getRandomElements(poolEnd, 2);

  return { imageStart, imageEnd, distractorsStart, distractorsEnd };
}

function getStartImageUrl(phonId, locale) {
  const word = locale === 'es-mx' ? spanishImages.startImages[phonId] : englishImages.startImages[phonId];
  if (!word) return null;
  const languageDir = locale === 'es-mx' ? '/spanish' : '';
  return `${baseUrl}${languageDir}/start_${phonId}_${word}.jpg`;
}

function getEndImageUrl(phonId, locale) {
  const word = locale === 'es-mx' ? spanishImages.endImages[phonId] : englishImages.endImages[phonId];
  if (!word) return null;
  const languageDir = locale === 'es-mx' ? '/spanish' : '';
  return `${baseUrl}${languageDir}/end_${phonId}_${word}.jpg`;
}

const englishImages = {
  startImages: {
    aa: "apple",
    aar: "arm",
    ao: "oar",
    b: "bat",
    ch: "cherry",
    d: "dog",
    ey: "eight",
    f: "fox",
    g: "gum",
    h: "hat",
    iyr: "ear",
    jh: "jam",
    k: "cat",
    l: "lion",
    m: "mouse",
    n: "nut",
    p: "pig",
    r: "red",
    s: "sock",
    t: "tent",
    th: "thumb",
    v: "vest",
    w: "web",
    z: "zebra",
  },
  endImages: {
    ao: "straw",
    aw: "cow",
    ay: "pie",
    b: "tub",
    ch: "watch",
    d: "bed",
    ehr: "pear",
    er: "picture",
    ey: "hay",
    f: "cough",
    g: "pig",
    iy: "bee",
    k: "picnic",
    l: "shell",
    m: "arm",
    n: "chicken",
    ng: "ring",
    ow: "arrow",
    oy: "toy",
    p: "soup",
    r: "car",
    s: "bus",
    t: "chest",
    th: "teeth",
    uw: "igloo",
    v: "cave",
    z: "cheese",
    zh: "garage",
  }
};

const spanishImages = {
  startImages: {
    A: "avion",
    B: "bandera",
    CH: "chango",
    D: "dedo",
    E: "estrella",
    F: "flor",
    G: "gato",
    H: "hombre",
    I: "iman",
    J: "llave",
    K: "cuna",
    L: "luna",
    M: "mano",
    N: "nido",
    NG: "nandu",
    O: "oso",
    P: "pescado",
    RR: "raton",
    S: "sombrero",
    T: "tortuga",
    U: "uva",
    X: "xilofono",
  },
  endImages: {
    A: "mapa",
    DH: "pared",
    E: "coche",
    L: "papel",
    N: "balon",
    O: "delicioso",
    S: "autobus",
    U: "tribu",
  }
}

function getPhonemeFromUrl(url) {
  const split = url.split("/");
  const fileName = split[split.length - 1];
  return fileName.split(".")[0];
}

function getPhonemeIds(PHON, locale) {
  return getAudioForPhonemes(PHON, locale).map(getPhonemeFromUrl);
}

export function getWordFromUrl(url) {
  const split = url.split("/");
  const fileName = split[split.length - 1].split(".")[0];
  return fileName.split("_")[2];
}
